import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CutomerKarshnas',
  templateUrl: './CutomerKarshnas.component.html',
  styleUrls: ['./CutomerKarshnas.component.scss']
})
export class CutomerKarshnasComponent implements OnInit {
  @Input() inner_Customer:number=0
  Edit_Customer_Record:Customer_Interface=Empty_Customer_Interface()

  constructor(
    private Alerify: AlertifyService,
    private Customer_Service: CustomerService,
  ) { }

  ngOnInit() {

    this.OnInitail_Form()
  }

  OnInitail_Form(){
    this.Customer_Service.GetSingle(this.inner_Customer).subscribe(
      data=>{

        this.Edit_Customer_Record=data['model']

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Dakhli=[]

          for (let itemDetail of item.dakhli_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Dakhli.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

          }

          item.dakhli_temp='-1'
        }

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Email=[]

            for (let itemDetail of item.email_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Email.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

            }
          item.email_temp='-1'
        }

        for(let item of this.DataList_KarshnasMasol)
        {
          item.Tel=[]

            for (let itemDetail of item.tel_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Tel.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

            }
          item.tel_temp='-1'
        }

      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#region  جدول کارشناس مسئول

  DataList_KarshnasMasol:Array<KarshnasMasol_Interface>=[]

  set_KarshnasMasol(model:Array<KarshnasMasol_Interface>)
  {
    this.DataList_KarshnasMasol=model
  }

  //#endregion

  Proccesing_OnSubmitForm_Csutomer:boolean=false
  OnSubmitFormCustomer(){

    this.Proccesing_OnSubmitForm_Csutomer=true
      var CustomerRecord:Customer_Interface=Empty_Customer_Interface()
      CustomerRecord.id=this.inner_Customer

      var Karshnas_Masol_Mobile:number=-1
      var Karshnas_Masol_Email:number=-1
      for(let item of this.DataList_KarshnasMasol)
      {
        if(!item.mobile && !this.Edit_Customer_Record.foreign)
        {
          Karshnas_Masol_Mobile=this.DataList_KarshnasMasol.indexOf(item)
          break
        }
  
        if(item.Email.length == 0 && this.Edit_Customer_Record.foreign)
        {
          Karshnas_Masol_Email=this.DataList_KarshnasMasol.indexOf(item)
          break
        }
      }
  

      if(Karshnas_Masol_Mobile>-1){
        this.Alerify.ErrorMessage("تلفن همراه کارشناس ردیف "+(Karshnas_Masol_Mobile+1)+" را وارد نمائید")
      }
      else if(Karshnas_Masol_Email>-1){
        this.Alerify.ErrorMessage("ایمیل کارشناس ردیف "+(Karshnas_Masol_Email+1)+" را وارد نمائید")
      }
      else{
        this.Customer_Service.EditCalibration(
          CustomerRecord,
          this.DataList_KarshnasMasol).subscribe(
          data=>{
            this.Proccesing_OnSubmitForm_Csutomer=false
            this.Alerify.SuccessMessage("اطلاعات ثبت شد")

          }
        )
      }

  }


}
